module.exports = new __parcel__URL__("Planet_B_teaser_ja.e1c588ae.webp").toString();